import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    first_name: '', last_name: '', nickname: '', email: '',
  });
  const [error, setError] = useState('');
  const [busy, setBusy]   = useState(false);

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    try {
      await register(form.email, form.first_name, form.last_name, form.nickname);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-6">
        <div className="card shadow-sm">
          <div className="card-body p-4">
            <h4 className="card-title mb-4">Create an Account</h4>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={submit}>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">First name</label>
                  <input type="text" name="first_name" className="form-control"
                    value={form.first_name} onChange={handle} required autoFocus />
                </div>
                <div className="col">
                  <label className="form-label">Last name</label>
                  <input type="text" name="last_name" className="form-control"
                         value={form.last_name} onChange={handle} required />
                </div>
                <div className="col">
                  <label className="form-label">Nickname</label>
                  <input type="text" name="nickname" className="form-control"
                         value={form.nickname} onChange={handle} required />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Email address</label>
                <input type="email" name="email" className="form-control"
                  value={form.email} onChange={handle} required />
              </div>
              <button className="btn btn-primary w-100" disabled={busy}>
                {busy ? 'Creating account…' : 'Register'}
              </button>
            </form>

            <p className="mt-3 text-center small">
              Already have an account? <Link to="/login">Log In</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
